import React from 'react'
import { ReactComponent as PhoenixSvg } from '../assets/phoenix-logo.svg'
import { cn } from '../lib/utils'

export default function PhoenixLogo({ className = '', alt = 'Phoenix Tracker' }) {
  return (
    <PhoenixSvg
      role="img"
      aria-label={alt}
      className={cn('text-app-primary-500', className)}
    />
  )
}
